<template>
  <div class="page-content">
    <div class="container mx-auto px-4 py-8">
      <!-- 头部区域 -->
      <header class=" bg-gradient-primary header-gradient text-white py-20 px-6 md:px-12">
        <div class="max-w-5xl mx-auto text-center">
          <h1 class="text-4xl md:text-5xl font-bold mb-6">展会文集</h1>
          <div class="text-lg text-white/90 max-w-3xl mx-auto">
            <p>全面分析展会行业发展趋势、市场规模、竞争格局及未来前景，为您的业务决策提供有力支持。</p>
          </div>
        </div>
      </header>

      <section class="mb-16 relative overflow-hidden rounded-2xl">
        <!-- 推荐报告网格布局 -->
        <div class="mt-12">
          <h2 class="text-2xl font-bold mb-6">干货推荐</h2>
          <div class="recommended-reports-grid">
            <!-- 推荐报告1 - 核心课件 -->
            <div class="glassmorphism card-hover rounded-xl overflow-hidden relative report-card">
              <div class="p-4 flex flex-col flex-grow">
                <h3 class="font-bold mb-2">
                  <i class="fas fa-chalkboard-teacher generic-icon"></i>
                  <span>会展场馆的新身份和新担当</span>
                </h3>
                <div class="flex items-center text-gray-500 mb-3">
                  <i class="far fa-calendar-alt mr-2"></i>
                  <span>2025-05-15</span>
                </div>
                <p class="text-gray-600 text-sm mb-4 flex-grow">探讨会展场馆在新时代背景下的角色转变与责任担当，分析场馆如何适应数字化、绿色化发展趋势。</p>
                <div class="collection-type-tag">核心课件</div>
              </div>
              <div class="price-tag paid">¥299</div>
            </div>

            <!-- 推荐报告2 - 展会报告 -->
            <div class="glassmorphism card-hover rounded-xl overflow-hidden relative report-card">
              <div class="p-4 flex flex-col flex-grow">
                <h3 class="font-bold mb-2">
                  <i class="fas fa-file-alt generic-icon"></i>
                  <span>中国会展行业营销策略及投资前景展望报告</span>
                </h3>
                <div class="flex items-center text-gray-500 mb-3">
                  <i class="far fa-calendar-alt mr-2"></i>
                  <span>2025-03-10</span>
                </div>
                <p class="text-gray-600 text-sm mb-4 flex-grow">全面分析中国会展行业的营销策略现状、趋势及投资前景，为企业提供决策参考。</p>
                <div class="collection-type-tag">展会报告</div>
              </div>
              <div class="price-tag paid">¥399</div>
            </div>

            <!-- 推荐报告3 - 核心课件 -->
            <div class="glassmorphism card-hover rounded-xl overflow-hidden relative report-card">
              <div class="p-4 flex flex-col flex-grow">
                <h3 class="font-bold mb-2">
                  <i class="fas fa-chalkboard-teacher generic-icon"></i>
                  <span>法兰克福会展中心成功的"密码"及可能的启发</span>
                </h3>
                <div class="flex items-center text-gray-500 mb-3">
                  <i class="far fa-calendar-alt mr-2"></i>
                  <span>2025-02-28</span>
                </div>
                <p class="text-gray-600 text-sm mb-4 flex-grow">深入解析法兰克福会展中心的成功经验，探讨其对中国会展场馆运营的启示与借鉴意义。</p>
                <div class="collection-type-tag">核心课件</div>
              </div>
              <div class="price-tag paid">¥499</div>
            </div>

            <!-- 推荐报告4 - 大咖分享 -->
            <div class="glassmorphism card-hover rounded-xl overflow-hidden relative report-card">
              <div class="p-4 flex flex-col flex-grow">
                <h3 class="font-bold mb-2">
                  <i class="fas fa-user-tie generic-icon"></i>
                  <span>谢永强：以多元文化构筑澳门会展独特竞争力</span>
                </h3>
                <div class="flex items-center text-gray-500 mb-3">
                  <i class="far fa-calendar-alt mr-2"></i>
                  <span>2025-01-20</span>
                </div>
                <p class="text-gray-600 text-sm mb-4 flex-grow">谢永强主席分享澳门如何利用多元文化优势，打造独特的会展竞争力，推动会展业发展。</p>
                <div class="collection-type-tag">大咖分享</div>
              </div>
              <div class="price-tag free">免费</div>
            </div>

            <!-- 推荐报告5 - 展会报告 (从搜索结果移来的最后一个卡片) -->
            <div class="glassmorphism card-hover rounded-xl overflow-hidden relative report-card">
              <div class="p-4 flex flex-col flex-grow">
                <h3 class="font-bold mb-2">
                  <i class="fas fa-file-alt generic-icon"></i>
                  <span>全球会展产业发展动向</span>
                </h3>
                <div class="flex items-center text-gray-500 mb-3">
                  <i class="far fa-calendar-alt mr-2"></i>
                  <span>2025-12-10</span>
                </div>
                <p class="text-gray-600 text-sm mb-4 flex-grow">全面梳理全球会展产业的最新发展动向，分析主要市场的发展特点与趋势，为行业提供国际视角。</p>
                <div class="collection-type-tag">展会报告</div>
              </div>
              <div class="price-tag paid">¥398</div>
            </div>
          </div>
        </div>
      </section>

      <!-- 搜索框区域 -->
      <section class="mb-16">
        <div class="glassmorphism p-8">
          <div class="flex flex-col md:flex-row gap-6">
            <div class="flex-grow relative">
              <input type="text" placeholder="搜索文集关键词..." class="search-input w-full px-5 py-4 pl-14 rounded-xl border border-gray-200 focus:border-blue-500 text-lg">
              <i class="fas fa-search absolute left-5 top-1/2 transform -translate-y-1/2 text-gray-400 text-xl"></i>
            </div>
            <div class="flex gap-4">
              <button class="bg-blue-800 hover:bg-blue-900 text-white px-8 py-4 rounded-xl font-semibold transition-colors flex items-center">
                <i class="fas fa-search mr-2"></i>
                搜索
              </button>
              <button class="bg-gray-200 hover:bg-gray-300 text-gray-700 px-6 py-4 rounded-xl font-semibold transition-colors flex items-center">
                <i class="fas fa-sliders-h mr-2"></i>
                高级筛选
              </button>
            </div>
          </div>
        </div>
      </section>

      <!-- 中部行业类别筛选区 -->
      <section class="mb-16">
        <div class="glassmorphism p-8">
          <h2 class="text-2xl font-bold mb-6 flex items-center">
            <i class="fas fa-filter text-blue-800 mr-2"></i>
            筛选条件
          </h2>

          <!-- 年份筛选 -->
          <div class="mb-6">
            <h3 class="text-lg font-semibold mb-3">按年份筛选</h3>
            <div class="flex flex-wrap gap-3">
              <button class="filter-button filter-active">全部年份</button>
              <button class="filter-button">2025</button>
              <button class="filter-button">2024</button>
              <button class="filter-button">2023</button>
              <button class="filter-button">2022</button>
              <button class="filter-button">2021</button>
            </div>
          </div>

          <!-- 价格类型筛选 -->
          <div class="mb-6">
            <h3 class="text-lg font-semibold mb-3">按价格类型筛选</h3>
            <div class="flex flex-wrap gap-3">
              <button class="filter-button filter-active">全部</button>
              <button class="filter-button bg-green-100 text-green-700 hover:bg-green-600">免费文集</button>
              <button class="filter-button bg-amber-100 text-amber-700 hover:bg-amber-600">付费文集</button>
            </div>
          </div>

          <!-- 文集类别筛选 -->
          <div class="mb-6">
            <h3 class="text-lg font-semibold mb-3">按文集类别筛选</h3>
            <div class="flex flex-wrap gap-3">
              <div class="category-tag bg-blue-100 text-blue-800 px-5 py-2 rounded-full font-medium cursor-pointer">
                全部类别
              </div>
              <div class="category-tag bg-gray-100 text-gray-800 px-5 py-2 rounded-full font-medium cursor-pointer">
                展会报告
              </div>
              <div class="category-tag bg-gray-100 text-gray-800 px-5 py-2 rounded-full font-medium cursor-pointer">
                大咖分享
              </div>
              <div class="category-tag bg-gray-100 text-gray-800 px-5 py-2 rounded-full font-medium cursor-pointer">
                核心课件
              </div>
            </div>
          </div>

          <!-- 展会行业类别筛选 -->
          <div>
            <h3 class="text-lg font-semibold mb-3">按展会行业类别筛选</h3>
            <div class="flex flex-wrap gap-3">
              <div class="category-tag bg-blue-100 text-blue-800 px-5 py-2 rounded-full font-medium cursor-pointer">
                全部行业
              </div>
              <div class="category-tag bg-gray-100 text-gray-800 px-5 py-2 rounded-full font-medium cursor-pointer">
                信息技术
              </div>
              <div class="category-tag bg-gray-100 text-gray-800 px-5 py-2 rounded-full font-medium cursor-pointer">
                汽车工业
              </div>
              <div class="category-tag bg-gray-100 text-gray-800 px-5 py-2 rounded-full font-medium cursor-pointer">
                医疗器械
              </div>
              <div class="category-tag bg-gray-100 text-gray-800 px-5 py-2 rounded-full font-medium cursor-pointer">
                建筑建材
              </div>
              <div class="category-tag bg-gray-100 text-gray-800 px-5 py-2 rounded-full font-medium cursor-pointer">
                食品饮料
              </div>
              <div class="category-tag bg-gray-100 text-gray-800 px-5 py-2 rounded-full font-medium cursor-pointer">
                服装纺织
              </div>
              <div class="category-tag bg-gray-100 text-gray-800 px-5 py-2 rounded-full font-medium cursor-pointer">
                机械设备
              </div>
              <div class="category-tag bg-gray-100 text-gray-800 px-5 py-2 rounded-full font-medium cursor-pointer">
                新能源
              </div>
              <div class="category-tag bg-gray-100 text-gray-800 px-5 py-2 rounded-full font-medium cursor-pointer">
                环保技术
              </div>
              <div class="category-tag bg-gray-100 text-gray-800 px-5 py-2 rounded-full font-medium cursor-pointer">
                文化创意
              </div>
              <div class="category-tag bg-gray-100 text-gray-800 px-5 py-2 rounded-full font-medium cursor-pointer">
                物流运输
              </div>
              <div class="category-tag bg-gray-100 text-gray-800 px-5 py-2 rounded-full font-medium cursor-pointer">
                金融服务
              </div>
              <div class="category-tag bg-gray-100 text-gray-800 px-5 py-2 rounded-full font-medium cursor-pointer">
                教育装备
              </div>
              <div class="category-tag bg-gray-100 text-gray-800 px-5 py-2 rounded-full font-medium cursor-pointer">
                农业科技
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 底部搜索结果展示区 -->
      <section>
        <div class="flex justify-between items-center mb-6">
          <div class="text-gray-500 text-xl font-semibold">
            共找到 <span class="text-blue-800 font-bold">10</span> 份文集
          </div>
          <!-- 排序下拉菜单 -->
          <div class="sort-dropdown">
            <button class="sort-button">
              <i class="fas fa-sort mr-2"></i>
              排序方式
              <i class="fas fa-chevron-down ml-2 text-xs"></i>
            </button>
            <div class="sort-dropdown-content">
              <a href="#" class="flex items-center">
                <i class="fas fa-check text-blue-800 mr-2"></i>
                默认排序
              </a>
              <a href="#">最新发布</a>
              <a href="#">下载量最高</a>
              <a href="#">价格从低到高</a>
              <a href="#">价格从高到低</a>
            </div>
          </div>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
          <!-- 搜索结果1 - 核心课件 -->
          <div class="glassmorphism card-hover rounded-xl overflow-hidden relative report-card">
            <div class="p-4 flex flex-col flex-grow">
              <h3 class="font-bold mb-2">
                <i class="fas fa-chalkboard-teacher generic-icon"></i>
                <span>会展场馆的新身份和新担当</span>
              </h3>
              <div class="flex items-center text-gray-500 mb-3">
                <i class="far fa-calendar-alt mr-2"></i>
                <span>2025-05-15</span>
              </div>
              <p class="text-gray-600 text-sm mb-4 flex-grow">探讨会展场馆在新时代背景下的角色转变与责任担当，分析场馆如何适应数字化、绿色化发展趋势。</p>
              <div class="collection-type-tag">核心课件</div>
            </div>
            <div class="price-tag paid">¥299</div>
          </div>

          <!-- 搜索结果2 - 核心课件 -->
          <div class="glassmorphism card-hover rounded-xl overflow-hidden relative report-card">
            <div class="p-4 flex flex-col flex-grow">
              <h3 class="font-bold mb-2">
                <i class="fas fa-chalkboard-teacher generic-icon"></i>
                <span>法兰克福会展中心成功的"密码"及可能的启发</span>
              </h3>
              <div class="flex items-center text-gray-500 mb-3">
                <i class="far fa-calendar-alt mr-2"></i>
                <span>2025-04-30</span>
              </div>
              <p class="text-gray-600 text-sm mb-4 flex-grow">深入解析法兰克福会展中心的成功经验，探讨其对中国会展场馆运营的启示与借鉴意义。</p>
              <div class="collection-type-tag">核心课件</div>
            </div>
            <div class="price-tag paid">¥328</div>
          </div>

          <!-- 搜索结果3 - 核心课件 -->
          <div class="glassmorphism card-hover rounded-xl overflow-hidden relative report-card">
            <div class="p-4 flex flex-col flex-grow">
              <h3 class="font-bold mb-2">
                <i class="fas fa-chalkboard-teacher generic-icon"></i>
                <span>中国会展走出去及国际合作</span>
              </h3>
              <div class="flex items-center text-gray-500 mb-3">
                <i class="far fa-calendar-alt mr-2"></i>
                <span>2025-04-15</span>
              </div>
              <p class="text-gray-600 text-sm mb-4 flex-grow">分析中国会展业国际化发展路径，探讨如何加强国际合作，提升中国会展品牌的全球影响力。</p>
              <div class="collection-type-tag">核心课件</div>
            </div>
            <div class="price-tag paid">¥418</div>
          </div>

          <!-- 搜索结果4 - 核心课件 -->
          <div class="glassmorphism card-hover rounded-xl overflow-hidden relative report-card">
            <div class="p-4 flex flex-col flex-grow">
              <h3 class="font-bold mb-2">
                <i class="fas fa-chalkboard-teacher generic-icon"></i>
                <span>以链为媒-从展馆运营到推动产业链协同发展</span>
              </h3>
              <div class="flex items-center text-gray-500 mb-3">
                <i class="far fa-calendar-alt mr-2"></i>
                <span>2025-03-28</span>
              </div>
              <p class="text-gray-600 text-sm mb-4 flex-grow">探讨如何从单一的展馆运营模式，延伸至产业链上下游，推动会展产业协同发展的创新路径。</p>
              <div class="collection-type-tag">核心课件</div>
            </div>
            <div class="price-tag free">免费</div>
          </div>

          <!-- 搜索结果5 - 大咖分享 -->
          <div class="glassmorphism card-hover rounded-xl overflow-hidden relative report-card">
            <div class="p-4 flex flex-col flex-grow">
              <h3 class="font-bold mb-2">
                <i class="fas fa-user-tie generic-icon"></i>
                <span>夏闻迪：锻造国机会展所长，服务国家战略所需</span>
              </h3>
              <div class="flex items-center text-gray-500 mb-3">
                <i class="far fa-calendar-alt mr-2"></i>
                <span>2025-03-15</span>
              </div>
              <p class="text-gray-600 text-sm mb-4 flex-grow">国机会展负责人夏闻迪分享如何发挥会展平台优势，服务国家战略，推动行业高质量发展。</p>
              <div class="collection-type-tag">大咖分享</div>
            </div>
            <div class="price-tag paid">¥288</div>
          </div>

          <!-- 搜索结果6 - 大咖分享 -->
          <div class="glassmorphism card-hover rounded-xl overflow-hidden relative report-card">
            <div class="p-4 flex flex-col flex-grow">
              <h3 class="font-bold mb-2">
                <i class="fas fa-user-tie generic-icon"></i>
                <span>谢永强：以多元文化构筑澳门会展独特竞争力</span>
              </h3>
              <div class="flex items-center text-gray-500 mb-3">
                <i class="far fa-calendar-alt mr-2"></i>
                <span>2025-02-25</span>
              </div>
              <p class="text-gray-600 text-sm mb-4 flex-grow">谢永强主席分享澳门如何利用多元文化优势，打造独特的会展竞争力，推动会展业发展。</p>
              <div class="collection-type-tag">大咖分享</div>
            </div>
            <div class="price-tag paid">¥268</div>
          </div>

          <!-- 搜索结果7 - 大咖分享 -->
          <div class="glassmorphism card-hover rounded-xl overflow-hidden relative report-card">
            <div class="p-4 flex flex-col flex-grow">
              <h3 class="font-bold mb-2">
                <i class="fas fa-user-tie generic-icon"></i>
                <span>"琶洲之星"专访：会展4.0时代，琶洲将迎更多全球卖家</span>
              </h3>
              <div class="flex items-center text-gray-500 mb-3">
                <i class="far fa-calendar-alt mr-2"></i>
                <span>2025-02-10</span>
              </div>
              <p class="text-gray-600 text-sm mb-4 flex-grow">专访琶洲会展中心负责人，探讨会展4.0时代的发展趋势，以及琶洲如何吸引更多全球卖家参与。</p>
              <div class="collection-type-tag">大咖分享</div>
            </div>
            <div class="price-tag paid">¥368</div>
          </div>

          <!-- 搜索结果8 - 大咖分享 -->
          <div class="glassmorphism card-hover rounded-xl overflow-hidden relative report-card">
            <div class="p-4 flex flex-col flex-grow">
              <h3 class="font-bold mb-2">
                <i class="fas fa-user-tie generic-icon"></i>
                <span>专访会展无忧创始人郝路路：一站式会展服务平台</span>
              </h3>
              <div class="flex items-center text-gray-500 mb-3">
                <i class="far fa-calendar-alt mr-2"></i>
                <span>2025-01-20</span>
              </div>
              <p class="text-gray-600 text-sm mb-4 flex-grow">郝路路分享如何打造一站式会展服务平台，解决会展行业痛点，提升会展效率与体验。</p>
              <div class="collection-type-tag">大咖分享</div>
            </div>
            <div class="price-tag free">免费</div>
          </div>

          <!-- 搜索结果9 - 展会报告 -->
          <div class="glassmorphism card-hover rounded-xl overflow-hidden relative report-card">
            <div class="p-4 flex flex-col flex-grow">
              <h3 class="font-bold mb-2">
                <i class="fas fa-file-alt generic-icon"></i>
                <span>中国会展行业营销策略及投资前景展望报告</span>
              </h3>
              <div class="flex items-center text-gray-500 mb-3">
                <i class="far fa-calendar-alt mr-2"></i>
                <span>2025-01-10</span>
              </div>
              <p class="text-gray-600 text-sm mb-4 flex-grow">全面分析中国会展行业的营销策略现状、趋势及投资前景，为企业提供决策参考。</p>
              <div class="collection-type-tag">展会报告</div>
            </div>
            <div class="price-tag paid">¥348</div>
          </div>

          <!-- 搜索结果10 - 展会报告 -->
          <div class="glassmorphism card-hover rounded-xl overflow-hidden relative report-card">
            <div class="p-4 flex flex-col flex-grow">
              <h3 class="font-bold mb-2">
                <i class="fas fa-file-alt generic-icon"></i>
                <span>国内会展营销现状及营销策略分析</span>
              </h3>
              <div class="flex items-center text-gray-500 mb-3">
                <i class="far fa-calendar-alt mr-2"></i>
                <span>2025-12-25</span>
              </div>
              <p class="text-gray-600 text-sm mb-4 flex-grow">深入剖析国内会展营销的现状与挑战，提出创新营销策略，助力会展企业提升市场竞争力。</p>
              <div class="collection-type-tag">展会报告</div>
            </div>
            <div class="price-tag paid">¥298</div>
          </div>
        </div>

        <!-- 分页区域 -->
        <div class="mt-12 flex justify-center">
          <div class="flex items-center space-x-2">
            <button class="px-4 py-2 rounded-lg bg-gray-100 text-gray-600 hover:bg-gray-200 transition-colors">
              <i class="fas fa-chevron-left"></i>
            </button>
            <button class="px-4 py-2 rounded-lg bg-blue-800 text-white">1</button>
            <button class="px-4 py-2 rounded-lg bg-gray-100 text-gray-600 hover:bg-gray-200 transition-colors">
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </section>
    </div>

  </div>
</template>
<script>
export default {
  name: "MeetingReport",
  mounted () {
    // 卡片悬停效果已经通过CSS实现

    // 模拟类别筛选点击效果
    const categoryTags = document.querySelectorAll('.category-tag');
    categoryTags.forEach(tag => {
      tag.addEventListener('click', function() {
        // 移除所有标签的选中状态
        const parentSection = this.closest('div[class*="mb-6"]');
        const siblingTags = parentSection.querySelectorAll('.category-tag');

        siblingTags.forEach(t => {
          t.classList.remove('bg-blue-100', 'text-blue-800');
          t.classList.add('bg-gray-100', 'text-gray-800');
        });

        // 添加当前标签的选中状态
        this.classList.remove('bg-gray-100', 'text-gray-800');
        this.classList.add('bg-blue-100', 'text-blue-800');
      });
    });

    // 模拟年份筛选点击效果
    const yearButtons = document.querySelectorAll('.filter-button');
    yearButtons.forEach(button => {
      button.addEventListener('click', function() {
        // 只移除同组按钮的选中状态
        const parentDiv = this.closest('div');
        const siblingButtons = parentDiv.querySelectorAll('.filter-button');

        siblingButtons.forEach(btn => {
          if (btn.classList.contains('bg-green-100') || btn.classList.contains('bg-amber-100')) {
            // 保持价格类型按钮的基础颜色
            btn.classList.remove('filter-active');
          } else {
            btn.classList.remove('filter-active', 'bg-blue-800', 'text-white');
            btn.classList.add('bg-blue-100', 'text-blue-800');
          }
        });

        // 添加当前按钮的选中状态
        if (this.classList.contains('bg-green-100') || this.classList.contains('bg-amber-100')) {
          this.classList.add('filter-active');
        } else {
          this.classList.add('filter-active', 'bg-blue-800', 'text-white');
          this.classList.remove('bg-blue-100', 'text-blue-800');
        }
      });
    });

    // 搜索功能模拟
    const searchButton = document.querySelector('.bg-blue-800');
    const searchInput = document.querySelector('.search-input');

    searchButton.addEventListener('click', function() {
      const keyword = searchInput.value.trim();
      if (keyword) {
        alert(`正在搜索关键词: ${keyword}`);
        // 实际应用中这里会发送搜索请求到服务器
      } else {
        alert('请输入搜索关键词');
      }
    });

    // 回车键触发搜索
    searchInput.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        searchButton.click();
      }
    });

    // 排序功能模拟
    const sortOptions = document.querySelectorAll('.sort-dropdown-content a');
    sortOptions.forEach(option => {
      option.addEventListener('click', function(e) {
        e.preventDefault();

        // 移除所有选项的选中状态
        sortOptions.forEach(opt => {
          opt.innerHTML = opt.innerHTML.replace('<i class="fas fa-check text-blue-800 mr-2"></i>', '');
        });

        // 添加当前选项的选中状态
        if (!this.innerHTML.includes('fa-check')) {
          this.innerHTML = '<i class="fas fa-check text-blue-800 mr-2"></i>' + this.innerHTML;
        }

        // 获取排序方式文本
        const sortText = this.textContent.trim();
        alert(`已按照 ${sortText} 排序`);
        // 实际应用中这里会发送排序请求到服务器
      });
    });
  }
}
</script>

<style scoped>
.bg-gradient-primary {
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
  border-radius: 20px 20px 0px 0px;
  margin-bottom: 20px;
  margin-top: 20px;
}

body {
  font-family: 'Noto Sans SC', sans-serif;
  background-color: #f8fafc;
  color: #1e293b;
}

.container {
  max-width: 1920px;
  margin: 0 auto;
}

.glassmorphism {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15);
}

.card-hover {
  transition: all 0.3s ease;
}

.card-hover:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 28px 0 rgba(31, 38, 135, 0.2);
}

.category-tag {
  transition: all 0.2s ease;
}

.category-tag:hover {
  background-color: #1e40af;
  color: white;
}

.report-card {
  height: 260px;
  display: flex;
  flex-direction: column;
}

.price-tag {
  position: absolute;
  bottom: 16px;
  right: 16px;
  padding: 3px 10px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 12px;
}

.price-tag.free {
  background-color: #10b981;
  color: white;
}

.price-tag.paid {
  background-color: #f59e0b;
  color: white;
}

.bg-gradient-primary {
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
}

.bg-gradient-secondary {
  background: linear-gradient(135deg, #2563eb 0%, #60a5fa 100%);
}

.blob {
  position: absolute;
  background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);
  filter: blur(60px);
  opacity: 0.3;
  border-radius: 50%;
  animation: blob-movement 15s infinite linear;
  z-index: -1;
}

@keyframes blob-movement {
  0% { transform: translate(0, 0) scale(1); }
  33% { transform: translate(5%, -10%) scale(1.3); }
  66% { transform: translate(-15%, 5%) scale(0.9); }
  100% { transform: translate(0, 0) scale(1); }
}

.filter-dropdown {
  position: relative;
  display: inline-block;
}

.filter-dropdown-content {
  display: none;
  position: absolute;
  background-color: white;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
  border-radius: 8px;
  overflow: hidden;
}

.filter-dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  transition: background-color 0.2s;
}

.filter-dropdown-content a:hover {
  background-color: #f1f1f1;
}

.filter-dropdown:hover .filter-dropdown-content {
  display: block;
}

.filter-dropdown:hover .filter-button {
  background-color: #1e40af;
  color: white;
}

.filter-button {
  padding: 8px 16px;
  border-radius: 8px;
  background-color: #dbeafe;
  color: #1e40af;
  border: none;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
}

.filter-active {
  background-color: #1e40af;
  color: white;
}

.search-input:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
}

.sort-dropdown {
  position: relative;
  display: inline-block;
}

.sort-dropdown-content {
  display: none;
  position: absolute;
  right: 0;
  background-color: white;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
  border-radius: 8px;
  overflow: hidden;
}

.sort-dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  transition: background-color 0.2s;
}

.sort-dropdown-content a:hover {
  background-color: #f1f1f1;
}

.sort-dropdown:hover .sort-dropdown-content {
  display: block;
}

.sort-button {
  padding: 8px 16px;
  border-radius: 8px;
  background-color: #f1f5f9;
  color: #64748b;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;
}

.sort-dropdown:hover .sort-button {
  background-color: #e2e8f0;
}

/* 推荐报告网格布局 - 确保五个卡片宽度一致 */
.recommended-reports-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 20px;
}

/* 响应式调整 */
@media (max-width: 1400px) {
  .recommended-reports-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media (max-width: 1200px) {
  .recommended-reports-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .recommended-reports-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 576px) {
  .recommended-reports-grid {
    grid-template-columns: 1fr;
  }
}

/* 通用图标样式 */
.generic-icon {
  font-size: 1.25rem;
  color: #3b82f6;
  opacity: 0.7;
  flex-shrink: 0;
  margin-top: 2px;
}

/* 文集类别标签样式 */
.collection-type-tag {
  font-weight: 600;
  color: #1e40af;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.8125rem;
  position: absolute;
  bottom: 16px;
  left: 16px;
}

/* 调整卡片文字区域的样式 */
.report-card .p-4 {
  padding: 1rem;
}

.report-card h3 {
  font-size: 1rem;
  margin-bottom: 0.5rem;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}

.report-card p {
  font-size: 0.875rem;
  margin-bottom: 0.75rem;
  line-height: 1.4;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
